var BillingMixins = require('billingmixins');
var OrgEntity = require('orgentity');
var OrgMember = require('orgmember');
var OrgMemberList = require('orgmemberlist');
var util = require('../lib/util.es6');


var Org = OrgEntity.extend($.extend(true, {}, BillingMixins, {
    initialize: function (data, options) {
        OrgEntity.prototype.initialize.apply(this, arguments);
        this.invitees = new OrgMemberList();
        this.members = new OrgMemberList();
    },
    
    post: function (method, data, callback) {
        data.org = this.id;
        return this.session.post(method, data, callback);
    },
    
    // BillingMixins
    subscribeUrl: 'subscribe-org-stripe',
    billingInfoUrl: 'org-billing',
    billingInfoParams: function () {
        return {
            org: this.id
        };
    },
    updateCustomerUrl: 'update-org-stripe-customer',
    reinstateSubscriptionUrl: 'reinstate-org-subscription',
    cancelStripeSubscriptionUrl: 'cancel-org-subscription',
    getReceiptUrl: function (chargeId) {
        return "/team-receipt/" + this.id + "/s/" + chargeId;
    },
    getInvoiceUrl: function (invoiceId) {
        return "/team-invoice/" + this.id + "/s/" + invoiceId;
    },
    getHostedInvoiceUrl: function (invoiceId) {
        return "/team-invoice/" + this.id + "/s-auth/" + invoiceId;
    },

    canSeeSubscription: function () {
        return this.isAdmin();
    },
    isOnlyAdmin: function () {
        return this.isAdmin() && !this.members.find(function (m) {
            return m.isAdmin();
        });
    },
    addMember: function (m, options) {
        var member = new OrgMember(m, {
            org: this,
            session: this.session
        });
        this.members.add(member, options);
    },
    addMembers: function (membersData) {
        _.each(membersData, function (member) {
            this.addMember(member, {silent: true});
        }, this);
        this.members.trigger('reset');
    },
    membersNeedSaving: function () {
        return this.members.any(function (m) {
            return m.needsSaving();
        }, this);
    },
    saveMembers: function (callback) {
        var membersToSave = this.members.groupBy(function (m) {
            if (m.needsRemoving()) {
                return 'remove';
            } else if (m.needsSaving()) {
                return 'saveAdmin';
            } else {
                return 'unchanged';
            }
        }, this);
        var remove = _.invoke(membersToSave['remove'], 'toJSON');
        var saveAdmin = _.invoke(membersToSave['saveAdmin'], 'toJSON');
        return this.post('edit-org-members', {
            remove: JSON.stringify(remove),
            save_admin: JSON.stringify(saveAdmin)
        }, _.bind(function (response) {
            if (response.success) {
                _.each(membersToSave['saveAdmin'], function (m) {
                    m.reset();
                }, this);
                _.each(membersToSave['remove'], function (m) {
                    this.members.remove(m);
                }, this);
                this.members.trigger('saved');
            }
            if (callback) {
                callback();
            }
        }, this));
    },
    remove: function (callback) {
        this.session.removeOrg(this, callback);
    },
    leave: function (callback) {
        this.session.leaveOrg(this, callback);
    },
    edit: function (data, callback) {
        data = $.extend({
            name: this.get('name'),
            billing_email: this.get('billing_email')
        }, data);
        return this.post('edit-org', data, _.bind(function (response) {
            if (response.success) {
                this.set(response.org);
            }
            if (callback) {
                callback(response);
            }
        }, this));
    },
    hasFetchedMembers: function () {
        return !!this.membersFetched;
    },
    haveJoined: function () {
        return this.get('join_time');
    },

    getMembers: function (callback, delay, failCount) {
        this.session.backend.get('org-members', {
            org: this.id
        }, _.bind(function (response) {
            if (response.error || response.success === false) {
                if (
                    failCount >= 10 ||
                    response.message == 'not_found' ||
                    response.message == 'auth' ||
                    response.message == 'database_down'
                ) {
                    // TODO error
                    if (callback) {
                        callback(response);
                    }
                } else {
                    if (delay) {
                        delay *= 2;
                        if (delay > 5000) {
                            delay = 5000;
                        }
                    } else {
                        delay = 500;
                    }
                    if (failCount) {
                        failCount++;
                    } else {
                        failCount = 1;
                    }
                    // TODO error
                    setTimeout(_.bind(function () {
                        this.getMembers(callback, delay, failCount);
                    }, this), delay);
                }
            } else {
                this.members.reset();
                this.membersFetched = true;
                this.addMembers(response);
            }
            if (callback) {
                callback();
            }
        }, this));
    },
    areConnectionsChosen: function () {
        return !!this.connections || this.hasIrcd();
    },
    joinConnections: function (data, callback) {
        return this.post('join-org-connections', data, callback);
    },
    addIrcd: function (data, callback) {
        var channels = util.parseChannels(data.channels, true);
        return this.post('set-org-ircd-channels', {
            channels: channels.join(' ')
        }, _.bind(function (response) {
            if (response.success) {
                this.set({
                    ircd: true,
                    ircd_channels: response.channels
                });
                if (response.cid) {
                    this.session.setFocusOnMakeServer(response.cid);
                }

            }
            if (callback) {
                callback(response);
            }
        }, this));
    },
    removeIrcd: function (callback) {
        return this.post('remove-org-ircd', {}, _.bind(function (response) {
            if (response.success) {
                this.set({
                    ircd: false,
                    ircd_channels: null
                });
            }
            if (callback) {
                callback(response);
            }
        }, this));
    },
    addNetwork: function (data, callback) {
        if (!this.connections) {
            this.connections = [];
        }
        data.channels = util.parseChannels(data.channels);
        var previousConnections = _.clone(this.connections);
        this.connections.push(data);
        this.saveConnections(previousConnections, callback);
    },
    removeNetwork: function (i, callback) {
        var previousConnections = _.clone(this.connections);
        this.connections.splice(i, 1);
        this.saveConnections(previousConnections, callback);
    },
    parseConnections: function () {
        if (this.get('connections')) {
            var previousConnections = _.clone(this.connections);
            try {
                this.connections = JSON.parse(this.get('connections'));
                if (!_.isArray(this.connections)) {
                    // Save empty list back to server
                    debug.warn('connections blob not an array', this.get('connections'));
                    this.connections = [];
                    this.saveConnections(previousConnections);
                }
            } catch (exc) {
                // Save empty list back to server
                debug.warn('invalid connections blob', this.get('connections'), exc);
                this.connections = [];
                this.saveConnections(previousConnections);
            }
            this.trigger('connectionsChange', {
                previous: previousConnections
            });
        }
    },
    saveConnections: function (previousConnections, callback) {
        if (!this.connections) {
            this.connections = [];
        }
        var json = JSON.stringify(this.connections);
        return this.post('set-org-connections', {
            connections: json
        }, _.bind(function (response) {
            if (response.success) {
                this.set({connections: json});
            } else {
                this.connections = previousConnections;
            }
            if (response.cids && response.cids[0]) {
                this.session.setFocusOnMakeServer(response.cids[0]);
            }
            if (callback) {
                callback(response);
            }
        }, this));
    },
    hasMembersOrInvitees: function () {
        return !!(this.members.length || this.invitees.length);
    },
    inviteMembers: function (callback) {
        if (this.invitees.length) {
            var members = _.invoke(this.invitees.filter(function (m) {
                return !m.isRemoved();
            }), 'toJSON');
            return this.post('invite-org-members', {
                members: JSON.stringify(members)
            }, _.bind(function (response) {
                if (response.success) {
                    this.addMembers(response.members);
                    this.invitees.reset();
                }
                if (callback) {
                    callback(response);
                }
            }, this));
        }
    },
    resendInvite: function (member, callback) {
        return this.post('resend-org-invite', {
            invite_email: member.get('invite_email')
        }, callback);
    }
}));


module.exports = Org;



//////////////////
// WEBPACK FOOTER
// ./app/src/model/org.js
// module id = 5gbS
// module chunks = 1